'use client'

import UIFlex, { UIFlexProps } from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import UILink from '@components/ui/UILink'
import { pxToRem } from '@ui/style/muiTheme'
import color from '@ui/style/color.theme'
import UIContainer from '@components/ui/UIContainer'
import Icon32Arrow from 'src/assets/icons/Icon32Arrow'
import { Box } from '@mui/joy'
import BgWrapper, { BgWrapperProps } from '@page/article/_components/common/BgWrapper'

export interface IssueHeaderProps extends Omit<UIFlexProps, 'ref'> {
	title: string
	href: string
	bgImg: BgWrapperProps['src']
	bgcolor?: string
}
const IssueHeader = ({ title, href, bgImg, bgcolor, ...props }: IssueHeaderProps) => {
	return (
		<UIFlex
			className="print-hide"
			paddingTop={{
				xs: pxToRem(bgImg?.bgMoImgUrl ? 124 : 24),
				md: pxToRem(bgImg?.bgTbImgUrl ? 156 : 28),
				lg: pxToRem(bgImg?.bgPcImgUrl ? 180 : 28),
				xl: pxToRem(bgImg?.bgPcImgUrl ? 224 : 32),
			}}
			paddingBottom={{ xs: pxToRem(24), md: pxToRem(28), xl: pxToRem(32) }}
			position="relative"
			bgcolor={bgcolor}
			{...props}
		>
			<BgWrapper display={bgImg?.bgPcImgUrl ? 'block' : 'none'} src={bgImg} />

			<UIContainer>
				<UILink href={href}>
					<UIFlex
						flexDirection="row"
						alignItems="center"
						sx={{
							display: 'inline-flex',
							'&>.icon': {
								transform: 'rotate(180deg)',
							},
						}}
					>
						<UIText
							fontSize={{ xs: pxToRem(24), md: pxToRem(26), lg: pxToRem(28) }}
							lineHeight={pxToRem(32)}
							fontWeight={700}
							color={color.colWhite}
							lineClamp={2}
						>
							{title}
						</UIText>
						<Box flexShrink={0} className="icon">
							<Icon32Arrow color={color.colWhite} />
						</Box>
					</UIFlex>
				</UILink>
			</UIContainer>
		</UIFlex>
	)
}

export default IssueHeader
